
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trwaja-prace",
      function () {
        return require("private-next-pages/trwaja-prace.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trwaja-prace"])
      });
    }
  